import Vue from "vue";
import {
  message,
  Modal
} from "ant-design-vue";

const namespaced = true;

function initialState() {
  return {
    events: {}
  };
}

const state = {
  events: initialState().events
};

const mutations = {
  SET_EVENT: (state, event) => {
    Vue.set(state.events, event.id, event);
  },
  UNSET_EVENT: (state, id) => {
    Vue.delete(state.events, id);
  }
};

const actions = {
  create: ({
    commit
  }, event) => {
    return new Promise((resolve, reject) => {
      Vue.axios
        .post(`/admin/event`, {
          event: event
        })
        .then(response => {
          commit("SET_EVENT", response.data.event);
          resolve();
        })
        .catch(error => {
          Vue.prototype.$log.error(error);
          reject(error);
        });
    });
  },
  saveWithPlan: ({
    commit
  }, data) => {
    return new Promise((resolve, reject) => {
      Vue.axios
        .post(
          `/admin/event/withPlan${
						data.event.id ? "/" + data.event.id : ""
					}`, {
            event: data.event,
            levels: data.levels
          }
        )
        .then(response => {
          commit("SET_EVENT", response.data.event);
          resolve();
        })
        .catch(error => {
          // Vue.prototype.$log.error(error);
          reject(error);
        });
    });
  },
  fetchSingle: ({
    commit
  }, {
    id,
    include,
    isPublic
  }) => {
    return new Promise((resolve, reject) => {
      Vue.axios
        .get(`${isPublic ? '/public' : ''}/event/${id}?include=${include}`)
        .then(response => {
          commit("SET_EVENT", response.data.event);
          resolve(response.data.event);
        })
        .catch(error => {
          Vue.prototype.$log.error(error);
          reject(error);
        });
    });
  },
  fetchAll: ({
    commit
  }) => {
    return new Promise((resolve, reject) => {
      Vue.axios
        .get(`/event`)
        .then(response => {
          for (const event of response.data.events) {
            commit("SET_EVENT", event);
          }
          resolve();
        })
        .catch(error => {
          Vue.prototype.$log.error(error);
          reject(error);
        });
    });
  },
  update: ({
    commit
  }, event) => {
    return new Promise((resolve, reject) => {
      Vue.axios
        .put(`/admin/event/${event.id}`, {
          event: event
        })
        .then(response => {
          commit("SET_EVENT", response.data.event);
          resolve(response.data.event);
        })
        .catch(error => {
          Vue.prototype.$log.error(error);
          reject(error);
        });
    });
  },
  delete: ({
    state,
    commit
  }, id) => {
    return new Promise((resolve, reject) => {
      const event = state.events[id];

      Modal.confirm({
        title: 'Delete booking',
        content: `Permanently delete event. Continue?`,
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'Cancel',
        onOk: () => {
          Vue.axios
            .delete(`/admin/event/${id}`)
            .then(response => {
              commit("UNSET_EVENT", id);
              message.success(
                `Event ${event.name} has been deleted!`
              );
              resolve();
            })
            .catch(error => {
              message.error(
                `Error while deleting event ${event.name}!`
              );
              Vue.prototype.$log.error(error);
            });
        }
      });
    });
  }
};

const getters = {
  all: (state, getters, rootState) => {
    if (rootState.isLoading) return {};
    return state.events;
  },
  asArray: (state, getters, rootState) => {
    if (rootState.isLoading) return [];
    return Object.values(state.events);
  }
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters
};